import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let SRTrouter = new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'home',
			component: () => import('./views/Home.vue')
		}, {
			path: '/introduction',
			name: 'introduction',
			component: () => import('./views/Introduction.vue')
		}, {
			path: '/demo',
			name: 'demo',
			component: () => import('./views/demo.vue'),
		}, {
			path: '/guide/:part',
			name: 'guide',
			component: () => import('./views/Guide.vue'),
		}, {
			path: '/treatment/:part',
			name: 'treatment',
			component: () => import('./views/Treatment.vue'),
		}, {
			path: '/news/:part',
			name: 'news',
			component: () => import('./views/News.vue'),
		}, {
			path: '/department/:part',
			name: 'department',
			component: () => import('./views/Department.vue'),
		}, {
			path: '/article/:id',
			name: 'article',
			component: () => import('./views/ArticleDetails.vue')
		}, {
			path: '/yanglao/:part',
			name: 'yanglao',
			component: () => import('./views/YangLao.vue')
		},  {
			path: '/dangjian/:part',
			name: 'dangjian',
			component: () => import('./views/DangJian.vue')
		}, {
			path: '/join',
			name: 'join',
			component: () => import('./views/Join.vue')
		}, {
			path: '/login',
			name: 'login',
			component: () => import('./views/Login.vue')
		}, {
			path: '/admin',
			name: 'admin',
			meta: {
				requireAuth: true
			},
			component: () => import('./views/Admin.vue'),
			children: [{
				path: '/admin/demo',
				name: 'admin_demo',
				component: () => import('./views/Admin/AdminDemo.vue')
			}, {
				path: '/admin/user',
				name: 'admin_user',
				component: () => import('./views/Admin/User.vue')
			}, {
				path: '/admin/dictionary',
				name: 'admin_dictionary',
				component: () => import('./views/Admin/DataDictionary.vue')
			}, {
				path: '/admin/dev',
				name: 'admin_dev',
				component: () => import('./views/Admin/Development.vue')
			}, {
				path: '/admin/guide',
				name: 'admin_guide',
				component: () => import('./views/Admin/GuideEditor.vue')
			}, {
				path: '/admin/treatment',
				name: 'admin_treatment',
				component: () => import('./views/Admin/TreatmentEditor.vue')
			}, {
				path: '/admin/news',
				name: 'admin_new',
				component: () => import('./views/Admin/News.vue')
			}, {
				path: '/admin/team',
				name: 'admin_team',
				component: () => import('./views/Admin/Team.vue')
			}, {
				path: '/admin/partner',
				name: 'admin_partner',
				component: () => import('./views/Admin/Partner.vue')
			}, {
				path: '/admin/honor',
				name: 'admin_honor',
				component: () => import('./views/Admin/Honor.vue')
			}, {
				path: '/admin/department',
				name: 'admin_department',
				component: () => import('./views/Admin/Department.vue')
			}, {
				path: '/admin/join',
				name: 'admin_join',
				component: () => import('./views/Admin/Join.vue')
			}, {
				path: '/admin/yanglao',
				name: 'admin_yanglao',
				component: () => import('./views/Admin/YangLaoEditor.vue')
			}, {
				path: '/admin/dangjian',
				name: 'admin_dangjian',
				component: () => import('./views/Admin/DangJianEditor.vue')
			}]
		}
	]
})


// 判断是否需要登录权限 以及是否登录
SRTrouter.beforeEach((to, from, next) => {
	// 判断是否需要登录权限
	if (to.matched.some(res => res.meta.requireAuth)) {
		// 判断是否登录
		if (sessionStorage.getItem('token')) {
			next()
		} else {
			// 没登录则跳转到登录界面
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		next()
	}
})

export default SRTrouter